<template>
  <div>
    <div class="flex">
      <div class="layer">
        <div class="copy-box">
          <el-form class="demo-form-inline"
                   v-show="liveIng">
            <el-form-item label="服務器">
              <el-input id="input-1"
                        v-model="livePush"
                        placeholder="服務器"
                        readonly></el-input>
              <el-button @click="_copy(1)"
                         type="success">複製</el-button>
            </el-form-item>
            <el-form-item label="串流密鑰">
              <el-input id="input-2"
                        v-model="safeUrl"
                        placeholder="串流密鑰"
                        readonly></el-input>
              <el-button @click="_copy(2)"
                         type="success">複製</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="copy-box copy-btn">
          <el-button v-if="!liveIng"
                     @click="publish()"
                     type="success">開始直播</el-button>
          <!-- <el-button v-else @click="finish" type="warning">結束直播</el-button> -->
          <el-button v-else
                     @click="process"
                     type="warning">查看流程</el-button>
        </div>
      </div>
      <div class="user">
        <p style="text-align: center;">報名人員（{{ isLive }}/{{ userList.length }}）</p>
        <div class="user-list">
          <p v-for="(item, index) in userList"
             :key="index"
             :class="item.isLive ? 'blue' : ''">
            <span class="userName">{{ item.name }}</span>
            <span class="isLiveTime">{{ item.isLiveTime }}</span>
          </p>
        </div>
      </div>

      <el-dialog title="流程"
                 :visible.sync="process_CPM"
                 width="760px">
        <div class="dialog-content">
          <p>1,請在百度瀏覽器中搜索 OBS Studio，進入官網並下載對應系統版本軟件</p>
          <img src="../assets/live-1.png" />
          <p>2,先新增視頻捕獲設備，後點擊設置</p>
          <img src="../assets/live-2.png" />
          <p>3,在推流項，填入服務器地址，密鑰</p>
          <img src="../assets/live-3.png" />
          <p>4,將視頻捕獲設備等顯示為啟用後，點擊開始推流進行直播</p>
          <img src="../assets/live-4.png" />
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="process_CPM = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
    <el-button @click="quit()"
               class="btn">返回</el-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      url: '',
      userList: [],
      isLive: 0,
      liveId: '',
      liveIng: false,
      videoNum: 0,
      microphoneNum: 0,
      livePush: '',
      safeUrl: '',
      process_CPM: false,
    };
  },
  mounted () {
    $('#pageHead').text('');
    // this.streamer = new streamer(document.getElementById('rtmp-streamer'));
    // let deviceList = [];
    // navigator.mediaDevices.enumerateDevices().then(devices =>{
    // 	// 可以检测摄像头和麦克风数量
    // 	devices.forEach(device =>{
    // 		deviceList.push(device.kind);
    // 		if (device.kind === "videoinput") this.videoNum++;
    // 		if (device.kind === "audioinput") this.microphoneNum++;
    // 	});
    // }).catch(function(err) {
    // 	window.console.log(err.name + ": " + err.message);
    // });
  },
  methods: {
    // 当复制内容为input ，textarea元素value时，不可设置为禁用，会导致选中失效
    _copy (num) {
      var ele = document.getElementById(num == 1 ? 'input-1' : 'input-2');
      ele.select()
      document.execCommand('copy')//执行浏览器 复制 命令
      this.$message({ type: 'success', message: '複製成功' })
    },

    publish () {
      this.liveIng = true;
      this.axios({
        url: '/manage/startEndLive',
        params: {
          type: 1,
          id: this.liveId
        },
        method: 'post'
      }).then(res => {
        if (res) {
          let msg = res.result;
          this.safeUrl = msg.safeUrl;
          this.livePush = msg.livePush;
        }
      });
    },
    process () {//流程
      this.process_CPM = true;
    },
    quit () {
      if (this.liveIng) {
        this.$confirm('直播結束前，請不要退出頁面，是否繼續?', '提示', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.liveIng = false;
          this.$router.back();
        }).catch(() => { });
      } else {
        this.$router.back();
      }
    },
    getUserNum () {
      this.axios.get('/manage/getManHistoricalAudienceList/noLoad?id=' + this.liveId).then(res => {
        if (res) {
          let list = res.result,
            isLive = 0;
          list.forEach(item => {
            if (item.isLive) {
              isLive++;
            }
          });
          this.isLive = isLive;
          this.userList = list;
          this.timeoutId = setTimeout(() => {
            this.getUserNum();
          }, 6000);
        }
      });
    }
  },
  created () {
    this.liveId = sessionStorage.getItem('liveId');
    this.getUserNum();
    this.axios.get('/manage/getManEnterClassroom?id=' + this.liveId).then(res => {
      if (res) {
        let msg = res.result;
        this.$nextTick(() => {
          $('#pageHead').text(msg.sectionName);
        });
        this.url = msg.liveFile;
      }
    });
    this.$router.beforeEach((to, from, next) => {//路由守卫
      if (from.name == 'live' && this.liveIng) {
        this.$confirm('直播結束前，請不要退出頁面，是否繼續?', '提示', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          next();
        }).catch(() => {
          next(false);
        });
      } else {
        next();
      }

    });
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  justify-content: space-between;
}
#rtmp-streamer,
.layer {
  width: 60vw;
  height: 70vh;
}
.layer {
  z-index: 1;
}
.user {
  width: 20vw;
  height: 70vh;
  background-color: #e0e2e4;
}
.user-list {
  height: 92%;
  overflow-y: auto;
}
.user-list .blue {
  color: #00b0e8;
}
.user-list p {
  margin: 10px;
  display: flex;
  justify-content: space-between;
  color: #656565;
  border-bottom: 1px solid #ccc;
  padding-bottom: 2px;
}
.btn {
  position: absolute;
  top: 90px;
  right: 45px;
}
.userName {
  max-width: 50%;
  font-size: 13px;
}
.isLiveTime {
  font-size: 12px;
}

.copy-box {
  min-width: 600px;
  max-width: 600px;
  margin: auto;
  padding-top: 220px;
}
.copy-btn {
  text-align: center;
  padding-top: 80px;
}
form.demo-form-inline >>> .el-form-item__label {
  width: 120px !important;
}
.el-form-item__content .el-input {
  width: 380px;
}
.el-form-item__content button.el-button.el-button--success {
  margin-left: 10px;
}

.dialog-content {
  height: 600px;
  overflow-x: auto;
}
.dialog-content img {
  width: 100%;
  margin: 5px 0;
}
</style>
